import { SelectProps } from '@mui/material';
import { Job, JobType, ThresholdJob } from 'interfaces/job';
import React, { ReactElement } from 'react';
import JobMultiSelect, { JobMultiSelectProps } from './JobMultiSelect';
import { ThresholdJobMarkersChip } from './ThresholdJobMarkersChip';

interface ThresholdJobMultiSelectProps extends Omit<SelectProps, 'onScroll' | 'label'> {
  selectedThresholdJobIds: string[];
  setSelectedThresholdJobIds: (jobIds: string[]) => void;
  restoredJobOrchestrationId?: string | null;
  onLoadFullJobs: (jobs: ThresholdJob[]) => void;
  helperText?: string;
  studyId?: string;
  errors?: JobMultiSelectProps['errors'];
  field?: JobMultiSelectProps['field'];
}

export const ThresholdJobMultiSelect = ({
  selectedThresholdJobIds,
  setSelectedThresholdJobIds,
  restoredJobOrchestrationId,
  onLoadFullJobs,
  helperText,
  studyId,
  errors,
  field,
}: ThresholdJobMultiSelectProps): ReactElement => {
  return (
    <JobMultiSelect
      label="Threshold Jobs"
      jobType={JobType.MultiplexThreshold}
      selectedJobIds={selectedThresholdJobIds}
      setSelectedJobIds={setSelectedThresholdJobIds}
      orchestrationIds={
        !selectedThresholdJobIds.length && restoredJobOrchestrationId ? [restoredJobOrchestrationId] : undefined
      }
      onLoadFullJobs={(jobs: Job[]) => onLoadFullJobs(jobs as ThresholdJob[])}
      renderJobOptionDetails={(job) => <ThresholdJobMarkersChip job={job as ThresholdJob} />}
      errors={errors}
      field={field || 'thresholdJobs'}
      helperText={helperText}
      studyId={studyId}
    />
  );
};
